import { useHTMLMediaAdapter } from "./useHTMLMediaAdapter";
import { useYouTubeAdapter } from "./useYouTubeAdapter";
import type { MediaController } from "./types";

type MediaType = "youtube" | "video" | "audio" | "recording";

export function useMediaAdapter(
  type: MediaType,
  src: string | null
): { controller: MediaController | null; ref?: React.RefObject<HTMLMediaElement>; containerId?: string } {
  // We need to call all hooks unconditionally due to React rules
  // Recordings use audio adapter since they are audio-only
  const htmlAdapter = useHTMLMediaAdapter(
    type === "video" ? "video" : "audio",
    src ?? ""
  );
  const youtubeAdapter = useYouTubeAdapter(src ?? "");

  if (type === "youtube") {
    return {
      controller: youtubeAdapter.controller,
      containerId: youtubeAdapter.containerId,
    };
  }

  return {
    controller: htmlAdapter.controller,
    ref: htmlAdapter.ref,
  };
}
